import { Flex, Box } from 'components/ui';
import { Row, Col } from 'react-grid-system';
import futuraIcon from 'img/futura-icon.svg';
import TraitsGallery from 'components/TraitsGallery';
import cellsPreview from 'img/preview-cells.png';
import globalTraits from 'img/global-traits.png';
import contextualTraits from 'img/contextual-traits.png';
import RoundedBox from 'components/Traits/RoundedBox';

interface SongTraitsProps {}

const SongTraits: React.FC<SongTraitsProps> = () => {
  return (
    <Row>
      <Col xs={12} sm={12} md={5}>
        <RoundedBox>
          <TraitsGallery
            items={[
              {
                title: 'Global traits',
                content: (
                  <Box pb={6}>
                    <img src={globalTraits} width="100%" alt="global traits" />
                  </Box>
                ),
              },
              {
                title: 'Contextual traits',
                content: (
                  <Box pb={6}>
                    <img src={contextualTraits} width="100%" alt="contextual traits" />
                  </Box>
                ),
              },
              {
                title: 'Clips',
                description:
                  'Each clip that appears in every cell, or intersection of section and layer, is considered a contextual trait because these are appearing in the context of the song, both individually and in combination. It is possible for the same cell across multiple songs to contain identical clips, but all songs must have a unique selection of clips.',
                content: (
                  <Box pb={6}>
                    <img src={cellsPreview} width="100%" alt="clips" />
                  </Box>
                ),
              },
            ]}
          />
        </RoundedBox>
      </Col>
      <Col xs={12} sm={12} md={7}>
        <RoundedBox maxHeight="470px" overflowY="scroll">
          <Flex mb={2} alignCenter>
            <img src={futuraIcon} width="24px" alt="infinity" style={{ opacity: 0.5 }} />
            <Box ml={3} fontWeight="bold" fontSize={3}>
              Futura song traits
            </Box>
          </Flex>
          <Box mt={3}>
            Futura has many traits - there are a myriad of resulting possibilities. Some traits are
            more distinctive than others. We invite the EB community to have fun while discovering
            them all!
          </Box>
          <Box mt={3}>
            Futura songs have two categories of traits: global and contextual. Global traits are
            those that each and every Futura NFT possesses. Contextual traits might (or might not)
            be present in any given song or section.
          </Box>

          <Box fontSize="16px" my={4}>
            Global Traits
          </Box>
          <ul>
            <li>
              These include: Generation, Tempo, Color Palette, Note Shape, Number of Twists and
              Distortion.{' '}
            </li>
            <li>
              Also, each individual clip has traits associated, such as Color Palette, Note Shape,
              Twists, Distortion, and Subtraction.
            </li>
          </ul>

          <Box fontSize="16px" my={4}>
            Contextual Traits
          </Box>
          <ul>
            <li>These include: Variations and Effects. </li>
            <li>
              Regarding variations, each intersection of section and layer can contain one of 16
              variants of named audio clips for that particular intersection that makes up a trait.
              For example, <b>Lead Intro: Idyllic Alien</b>
            </li>
            <li>
              Regarding effects, there are 3 different types - light, particles, special - that are
              detailed below.
            </li>
          </ul>
        </RoundedBox>
      </Col>
    </Row>
  );
};

export default SongTraits;
